import { AssetType, } from '@zattoo/playback-sdk';
export const MAX_TIMESHIFT_OFFSET = 10800;
export const PlayerWithLive = (Base) => {
    return class extends Base {
        playLive(channelId, playOptions) {
            return this.requestStream({
                playOptions,
                assetType: AssetType.LIVE,
                watchRequestParams: {
                    cid: channelId,
                    timeshift: MAX_TIMESHIFT_OFFSET,
                },
            });
        }
    };
};
